import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import AdministratorsListView from './administrators';

const AdministratorsView = () => (
  <Routes>
    <Route path="administrators/*" element={<RolePrivateRoute component={AdministratorsListView} />} />
    <Route index element={<Navigate to="administrators" replace />} />
  </Routes>
);

export default AdministratorsView;
